<template>
  <div class="flex flex-col gap-10 xl:flex-row sm:mx-4">
    <div class="mx-auto max-w-3xl flex flex-col bg-white shadow p-5 w-full">
      <base-alert text="company_import" type="info" />
      <form @submit.prevent="activate">
        <FormError :errors="errors" />
        <div class="flex mt-8 justify-between">
          <span class="font-semibold">{{ $t(`mygwf.components.Label.is_distributor`) }}</span>
          <div class="flex flex-col sm:grid sm:grid-cols-2 gap-5 sm:px-8">
            <label class="flex items-baseline">
              <input :value="true" v-model="isDistributor" type="radio" />
              <span class="ml-2">{{ $t(`mygwf.components.Label.yes`) }}</span>
            </label>
            <label class="flex items-baseline">
              <input :value="false" v-model="isDistributor" type="radio" />
              <span class="ml-2">{{ $t(`mygwf.components.Label.no`) }}</span>
            </label>
          </div>
        </div>
        <div class="flex mt-6 space-x-2 lg:space-x-4">
          <base-input v-model.trim="representative" type="email" required focused label="email" />
        </div>
        <hr class="my-6" />
        <base-button type="submit" :loading="isActivating" action="submit" class="mt-2 w-full" />
      </form>
    </div>
    <div class="bg-white mx-auto max-w-3xl w-full shadow overflow-hidden">
      <div class="px-4 py-5 sm:px-8">
        <h3 class="text-xl font-medium text-gray-900">
          {{ $t(`mygwf.components.Card.company_details`) }}
        </h3>
        <p class="mt-2 max-w-2xl text-gray-500">
          {{ $t(`mygwf.components.Card.erp_info`) }}
        </p>
      </div>
      <div class="border-t border-gray-200">
        <dl>
          <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-8">
            <dt class="font-medium text-gray-500">
              {{ $t(`mygwf.components.Form.customer_account`) }}
            </dt>
            <dd class="mt-1 text-right font-semibold text-gray-900 sm:mt-0 sm:col-span-2">
              {{ company.area }}-{{ company.customer_account }}
            </dd>
          </div>
          <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-8">
            <dt class="font-medium text-gray-500">
              {{ $t(`mygwf.components.Form.name`) }}
            </dt>
            <dd class="mt-1 text-right font-semibold text-gray-900 sm:mt-0 sm:col-span-2">
              {{ company.name }}
            </dd>
          </div>
          <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-8">
            <dt class="font-medium text-gray-500">
              {{ $t(`mygwf.components.Form.address`) }}
            </dt>
            <dd class="mt-1 text-right font-semibold text-gray-900 sm:mt-0 sm:col-span-2">
              {{ company.address }}
            </dd>
          </div>
          <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-8">
            <dt class="font-medium text-gray-500">
              {{ $t(`mygwf.components.Form.city`) }}
            </dt>
            <dd class="mt-1 text-right font-semibold text-gray-900 sm:mt-0 sm:col-span-2">
              {{ company.city }}
            </dd>
          </div>
          <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-8">
            <dt class="font-medium text-gray-500">
              {{ $t(`mygwf.components.Form.country`) }}
            </dt>
            <dd class="mt-1 text-right font-semibold text-gray-900 sm:mt-0 sm:col-span-2">
              {{ getCountryName(company.country) }}
            </dd>
          </div>
          <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-8">
            <dt class="font-medium text-gray-500">
              {{ $t(`mygwf.components.Form.zip`) }}
            </dt>
            <dd class="mt-1 text-right font-semibold text-gray-900 sm:mt-0 sm:col-span-2">
              {{ company.zip }}
            </dd>
          </div>
          <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-8">
            <dt class="font-medium text-gray-500">
              {{ $t(`mygwf.components.Form.representative`) }}
            </dt>
            <dd class="mt-1 text-right font-semibold text-gray-900 sm:mt-0 sm:col-span-2">
              {{ company.representative }}
            </dd>
          </div>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import {BaseAlert, BaseInput, BaseButton} from '@/components/base'
import store from '@/state/store.js'
import FormError from '@/components/shared/FormError.vue'
import {getCountryName} from '@/state/helpers/mixins.js'

export default {
  async beforeRouteEnter(to, from, next) {
    try {
      const data = await store.dispatch('companies/checkActive', {id: to.params.id})
      next(vm => {
        // vm.visible = true
        // delete data.updated
        // delete data.parent
        // delete data.distributor
        // delete data.is_distributor
        // delete data.id
        // delete data.is_active
        // data.created = vm.$options.filters.dateFormat(data.created)
        vm.company = data
      })
    } catch (error) {
      next()
    }
  },

  components: {
    BaseAlert,
    BaseInput,
    BaseButton,
    FormError,
  },

  data() {
    return {
      company: {},
      errors: {},
      representative: '',
      isDistributor: true,
      isActivating: false,
    }
  },

  mixins: [getCountryName],

  methods: {
    async activate() {
      this.isActivating = true
      try {
        await this.$store.dispatch('companies/activate', {
          id: this.$route.params.id,
          is_distributor: this.isDistributor,
          representative_email: this.representative,
        })
        this.$store.dispatch('app/notification', {type: 'success', group: 'app', text: `updated`})
        this.errors = {}
        this.$router.push({name: 'Companies', replace: true})
      } catch (errors) {
        this.errors = errors
      } finally {
        this.isActivating = false
      }
    },
  },
}
</script>
